const {Backbone} = require('backboneAdapter');
import NavBarView from 'js/views/navbar.view';
import VoucherRedeemView from 'js/views/voucher.redeem.view';
require('l10n');

    export default Backbone.Router.extend({
        routes: {
            ":code": "idRoute",
            "": "defaultRoute"
        },
        initialize: function () {
            console.info("Initializing Voucher Redeem Router");
            this.navbar = new NavBarView();
        },
        defaultRoute: function () {
            console.info("defaultRoute");

            this.removeAllEvents(this.voucherRedeemView);
            this.voucherRedeemView = new VoucherRedeemView();
        },
        idRoute: function (code) {
            console.info("idRoute");
            this.removeAllEvents(this.voucherRedeemView);
            this.voucherRedeemView = new VoucherRedeemView({code});
        },
        removeAllEvents: function (view) {
            if (view) {
                view.$el.off();
                view.$el.empty();
                view.undelegateEvents();
                view = null;
            }
        }
    });
